import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MinuteConversionPipe } from 'src/app/utility/pipe/minute-conversion/minute-conversion.pipe';
import { LanguageCheckPipe } from 'src/app/utility/pipe/language-check/language-check.pipe';
import {
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material';
import { LocalTimePipe } from 'src/app/utility/pipe/local-time/local-time.pipe';
import { CustomMaxDirective } from 'src/app/utility/directive/custom-max/custom-max-validator.directive';
import { CustomMinDirective } from 'src/app/utility/directive/custom-min/custom-min-validator.directive';
import { OnlyEnglishDirective } from 'src/app/utility/directive/language-check/only-english.directive';
import { FilterListPipe } from 'src/app/utility/pipe/filter-list/filter-list.pipe';
import { ReversePipe } from 'src/app/utility/pipe/reverse';
import { FileModalComponent } from '../file-modal/file-modal.component';
import { NgmatModule } from '../ngmat/ngmat.module';
import { FileUploadModule } from 'ng2-file-upload';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ShrinkTextPipe } from 'src/app/utility/pipe/shrink-text/shrink-text.pipe';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { PreventExponentialDirective } from 'src/app/utility/directive/prevent-exponential/prevent-exponential.directive';

@NgModule({
  declarations: [
    MinuteConversionPipe,
    LanguageCheckPipe,
    LocalTimePipe,
    CustomMaxDirective,
    CustomMinDirective,
    OnlyEnglishDirective,
    FilterListPipe,
    ReversePipe,
    FileModalComponent,
    ShrinkTextPipe,
    PreventExponentialDirective,
  ],
  imports: [CommonModule, NgmatModule, FileUploadModule, AngularEditorModule, RecaptchaModule, RecaptchaFormsModule],
  exports: [
    MinuteConversionPipe,
    LanguageCheckPipe,
    LocalTimePipe,
    CustomMaxDirective,
    CustomMinDirective,
    OnlyEnglishDirective,
    FilterListPipe,
    ReversePipe,
    FileUploadModule,
    AngularEditorModule,
    ShrinkTextPipe,
    RecaptchaModule, 
    RecaptchaFormsModule,
    PreventExponentialDirective
  ],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaKey,
      } as RecaptchaSettings,

    },
  ],
  entryComponents: [FileModalComponent],
})
export class CustomModule {}
